<template>
  <div class="goods-info-wrapper">
    <div
      class="shop-detail-btn"
      @click="goShopDetail"
    >
      <p class="shop-name">{{shopInfo.name}}</p>
      <i class="icon-outline_entrance"></i>
    </div>
    <CateResult
      class="order-cate-result"
      v-if="cateInfo"
      size="small"
      :shopInfo="cateInfo"
      :noCard="true"
      :ellipsis="false"
    />
    <div class="fee-box">
      <FeeItem
        class="item-no-margin-bottom"
        v-for="(item, index) in showList"
        :key="'fee' + index"
        :label="item.key"
        :value="item.value"
        :hasBorder="+item.type === 1"
      />
    </div>
    <el-button
      class="receipt-btn"
      v-if="receiptBtn"
      dark
      outline
      :disabled="receiptBtn.disable"
      @click.native="getReceipt(receiptBtn.disable)"
    >{{ receiptBtn.name }}</el-button>
  </div>
</template>

<script>
import { downloadPopupShow } from '@/components/DownloadApp/downloadPopup.js';
import CateResult from '@/components/CateResult'
import FeeItem from './feeitem.vue'
export default {
  name: 'OrderGoodsInfoCard',
  components: {
    CateResult,
    FeeItem,
  },
  props: {
    info: Object,
  },
  data() {
    return {
      shopInfo: {},
      showList: [],
      cateInfo: null,
      receiptBtn: null,
    }
  },
  watch: {
    info(nVal, oVal) {
      if (nVal !== oVal) {
        this.init(nVal)
      }
    }
  },
  mounted() {
    this.init(this.info)
  },
  methods: {
    downloadPopupShow,
    init(nVal) {
      this.shopInfo = nVal?.shopInfo
      this.cateInfo = {
        shopName: nVal?.shopInfo?.name,
        items: nVal?.items
      }
      this.showList = nVal?.showList
      this.receiptBtn = nVal?.receiptBtn
    },
    goShopDetail() {
      // 跳转门店详情
      this.$router.push({
        path: `/store/${this.shopInfo.shopId}/${this.shopInfo.shopName}`,
        query: { pl: this.$route.query.pl }
      });
    },
    getReceipt(disabled) {
      if (disabled) return
      this.$trackEvent({
        eventId: 'sailing_c_x_download_app_ck',
        eventLabel: '下载app点击',
        attrs: {
          from: 1
        }
      })
      this.downloadPopupShow()
    }
  }
}
</script>
<style lang="scss">
.order-cate-result .limit-txt-wrapper {
  font-family: 'Aspira Medium' !important;
}
</style>
<style lang="scss" scoped src="./index.scss"></style>
